import React, { useState, useEffect, useRef } from 'react';

export const SplashScreen = ({ onComplete }) => {
  const [isVisible, setIsVisible] = useState(() => { try { return !window.localStorage.getItem('lamko_splash_seen'); } catch (e) { return true; } });
  const [isFading, setIsFading] = useState(false);
  const videoRef = useRef(null);
  const hasEnded = useRef(false);

  const handleVideoEnd = () => {
    if (hasEnded.current) return;
    hasEnded.current = true;
    try { window.localStorage.setItem('lamko_splash_seen', '1'); } catch (e) {}
    
    setIsFading(true);
    setTimeout(() => {
      setIsVisible(false);
      if (onComplete) onComplete();
    }, 800);
  };

  useEffect(() => {
    const video = videoRef.current;
    
    // Fallback timeout - end splash after 5 seconds max
    const fallbackTimer = setTimeout(() => {
      handleVideoEnd();
    }, 5000);
    
    if (video) {
      const playVideo = async () => {
        try {
          await video.play();
        } catch (err) {
          console.log('Autoplay prevented, skipping intro');
          handleVideoEnd();
        }
      };
      
      playVideo();
    }
    
    return () => clearTimeout(fallbackTimer);
  }, []);

  const handleVideoError = () => {
    handleVideoEnd();
  };

  /* HOME_ONLY: intro video only on the landing page */
  try { if ((window.location.pathname || "/") !== "/") return null; } catch (e) {}
  if (!isVisible) return null;

  return (
    <div 
      className={`fixed inset-0 z-40 bg-black flex items-center justify-center transition-opacity duration-700 pt-20 ${
        isFading ? 'opacity-0' : 'opacity-100'
      }`}
    >
      <button onClick={handleVideoEnd} data-testid="splash-skip" className="absolute top-6 right-6 z-50 px-4 py-2 rounded-lg bg-white/10 border border-white/40 text-white text-sm font-medium hover:bg-white/20">Skip</button>
        <video
        ref={videoRef}
        src="https://customer-assets.emergentagent.com/job_lamko-b2b/artifacts/9gclcc1o_generated-video.mp4"
        className="w-full h-full object-contain md:object-cover"
        muted
        playsInline
        autoPlay
        onEnded={handleVideoEnd}
        onError={handleVideoError}
      />
    </div>
  );
};
